
import {Component, Vue} from "vue-property-decorator";
import {IViewType, IWeekdaySelection} from "@/auxillary";

@Component({})
export default class CalendarView extends Vue {
  readonly availableViewTypes: IViewType[] = [
    {identifier: "day", displayName: "Tag"},
    {identifier: "4day", displayName: "4 Tage"},
    {identifier: "week", displayName: "Woche"},
    {identifier: "month", displayName: "Monat"}
  ];
  readonly selectedViewType: IViewType = this.availableViewTypes[3];

  availableWeekdaySelections: IWeekdaySelection[] = [
    {text: 'Mo - So', weekdays: [1, 2, 3, 4, 5, 6, 0]},
    {text: 'Mo - Fr', weekdays: [1, 2, 3, 4, 5]}
  ];
  selectedWeekdaySelection: IWeekdaySelection = this.availableWeekdaySelections[0];
}
